import { Fragment, type ReactNode } from 'react';

const TIMESTAMP_PATTERN = /\b(\d{1,2}):([0-5]\d)(?::([0-5]\d))?\b/g;

function parseTimestamp(match: RegExpExecArray): number {
  const a = Number(match[1]);
  const b = Number(match[2]);
  const c = match[3] !== undefined ? Number(match[3]) : null;
  if (c !== null) return a * 3600 + b * 60 + c;
  return a * 60 + b;
}

export function renderCommentWithTimestamps(
  content: string,
  onSeek: (seconds: number) => void,
  goToLabel: (display: string) => string,
): ReactNode {
  const parts: ReactNode[] = [];
  let lastIndex = 0;
  let match: RegExpExecArray | null;
  TIMESTAMP_PATTERN.lastIndex = 0;
  let key = 0;

  while ((match = TIMESTAMP_PATTERN.exec(content)) !== null) {
    if (match.index > lastIndex) {
      parts.push(<Fragment key={key++}>{content.slice(lastIndex, match.index)}</Fragment>);
    }
    const seconds = parseTimestamp(match);
    const display = match[0];
    parts.push(
      <button
        key={key++}
        type="button"
        onClick={() => onSeek(seconds)}
        className="text-brand-primary hover:underline tabular-nums cursor-pointer focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-border-focus focus-visible:ring-offset-2 rounded"
        aria-label={goToLabel(display)}
      >
        {display}
      </button>,
    );
    lastIndex = match.index + display.length;
  }

  if (lastIndex < content.length) {
    parts.push(<Fragment key={key++}>{content.slice(lastIndex)}</Fragment>);
  }

  return parts.length > 0 ? parts : content;
}
